<template>
    <iModal
        v-model="showNeeds"
        title="免费发布供需"
        :mask-closable="false"
        @on-cancel="cancel">
        <div class="admin-add">
            <div class="admin-add-content">
            <Form
                label-position="right"
                :label-width="100"
                @submit.native.prevent
            >
                <FormItem label="供需类型：">
                            <Button
                                    v-for="(item,index) in typeTabs"  :key="index"
                                    @click="activeShow = index;selectTab = item;"
                                    class="btn"
                                    :class="activeShow == index ? 'primary' : ''"
                            >
                                {{item}}
                            </Button>
                </FormItem>
                <FormItem label="我需要：">
                    <Input v-model="content" type="textarea" :rows="4" placeholder="如：产品名称、数量、具体要求等"  style="margin-bottom:20px;"/>
                    <div>
                        <upload
                            ref="upload1"
                            :fileList="uploadBanner"
                            :config="uploadBannerConfig"
                            @upload-ok="bannerOK"
                        />
                    </div>
                </FormItem>
            </Form>
            </div>
         </div>
        <div slot="footer">
            <Button type="primary" @click="handleSubmit">发布需求</Button>
            <Button @click="cancel">取消</Button>
        </div>
    </iModal>
</template>
<script>
import { mapActions , mapGetters} from 'vuex';
import upload from "@components/upLoad/upLoad2";
export default {
    data(){
        return{
            showTabs: '1',
            showNeeds:false,
            typeTabs:['采购产品','供应产品','征求服务'],
            activeShow:-1,
            selectTab:'',
            content:'',
            uploadBanner: [], // 活动图
            config: {
                fileType: "img",
                headers: {},
                action: "",
                format: ["jpg", "jpeg", "png"],
                "max-size": 2048,
                remind:
                "(图片要求：2M以下的jpg或png，最多上传5张)",
                limitNum: 5,
            },
            editModel:false,
            editId:'',
        }
    },
    computed:{
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            userInfo:'getUser',
            exhibitionInfo:'getExhibitionInfo',
            exhibitionId:'getExhibitionId'
        }),
        uploadBannerConfig() {
            let config = JSON.parse(JSON.stringify(this.config));
            config.id = "upload_1";
            config.headers = this.formHeaders;
            config.action = this.uploadUrl;
            config.remind =
                "(图片要求：2M以下的jpg或png，最多上传5张)";
            return config;
        },
        isRegOk(){
            return this.userInfo&&this.userInfo.inMember&&this.userInfo.inMember.userRole&&this.userInfo.inMember.userRole!='VISITOR'&&this.userInfo.inMember.userRole!='Visitor'
        }
    },
    components: {
        upload,
    },
    created(){

    },
    methods:{
        ...mapActions({
            supplyDemandSubmit:'news/supplyDemand',
            editSupply:'news/editSupply',
            unverifiedDialog:'unverifiedDialog'
        }),
        open(item = null){
            if(!(this.userInfo&&this.userInfo.userId&&this.userInfo.phone)){
                this.unverifiedDialog(this)
                return;
            }
            this.showNeeds = true;
            if(item){ // 编辑模式
                this.editModel = true;
                this.editId = item.id;
                this.uploadBanner = item.imgUrls || [];
                this.selectTab = item.type;
                this.typeTabs.forEach((c,i)=>{
                    if(c == this.selectTab) {
                       this.activeShow = i
                    }
                })
                this.content = item.content;
            }
        },
        bannerOK(list) {
            this.uploadBanner = list;
        },
        async handleSubmit(){

            if(!this.editModel){ // 新增模式
                if (!this.content) {
                    this.$Message.error("请输入供需内容");
                    return;
                }
                let opt = {
                    memberId: this.userInfo.id,
                    content: this.content,
                    publisherType: 0,
                    originName: this.exhibitionInfo.name || "平台",
                    exhibitionId: this.exhibitionId,
                    type:this.selectTab,
                };
                if (this.uploadBanner.length) {
                    opt.imgUrls = this.uploadBanner.join(";");
                }
                let data = await this.supplyDemandSubmit(opt);
                if (data && data.result) {
                    this.$Message.success('提交成功');
                    this.$emit('finish');
                } else {
                   this.$Message.error(data.message);
                }
                this.cancel();
            } else { // 编辑模式
                let opt={
                    id:this.editId,
                    content:this.content,
                    auditState:0,
                    type:this.selectTab,
                }
                if (this.uploadBanner.length) {
                    opt.imgUrls = this.uploadBanner.join(";");
                }
                let res= await this.editSupply(opt);
                if(res.result){
                    this.$Message.success('提交成功');
                    this.$emit('finish');
                }else{
                    this.$Message.error(res.message);
                }
                this.cancel();
            }
        },
        cancel(){
            this.showNeeds = false;
            this.content = '';
        },
    }
    
}
</script>
<style lang="scss" scoped>
.btn{
    margin-right: 12px;
    width: 110px;
    &:last-child{
        margin-right: 0;
    }
}
.primary{
   color: #fff;
    background-color: #2d8cf0;
    border-color: #2d8cf0;
}
    .admin-add-content{
        padding-right: 30px;
    }
</style>
